import React, { useContext } from "react";
import "./RelatedProducts.css";
import Item from "../Items/Item";
import default_img from "../../Components/Assets/default_img.png";
import { ShopContext } from "../../Context/ShopContext";
import PageLoader from "../Assets/PageLoader/PageLoader";

const mainURL = process.env.REACT_APP_API_BASE_URL;

const RelatedProducts = (props) => {
  const { all_products, loading } = useContext(ShopContext);

  if (loading) {
    return <PageLoader text="Loading related products" />;
  }

  if (!all_products.length) {
    return null; // or <p>No related products</p>
  }

    let filteredProducts = all_products.filter(
    (item) => Number(item.item_category_id) === Number(props.categoryId)
  );

  return (
    <div className="relatedproducts">
      <h1>Related Products</h1>
      <hr />

      <div className="relatedproducts-item">
        {filteredProducts.slice(0, 4).map((item) => { 
          const imagePath =
            item?.product_images?.[0]?.image_path
              ? `${mainURL}/${item.product_images[0].image_path}`
              : default_img;

          const sellingPrice =
            item?.product_cost?.[0]?.selling_price ?? 0;

          return (
            <Item
              key={item.item_id}
              id={item.item_id}
              name={item.item_name}
              image={imagePath}
              is_wishlist={item.is_wishlist}
              new_price={sellingPrice}
              old_price={sellingPrice}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RelatedProducts;
